import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../'

import Styles from './PlanScorecardToActionCenter.css'


@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardToActionCenter extends Component {
  render() {
    return (
      <ContainerDivs>
        <div styleName='take-action-share'>
          <div styleName='take-action-label'>
            <h2>
              Want more sustainable options in your 401(k) plan?
            </h2>
            <p>
              Learn how to work with your employer to ensure your retirement plan is sustainably invested.
            </p>
          </div>
          <div styleName='take-action-icons'>
            <div styleName='scorecard-methodology-link'>
              <Link
                to={config.routes.eduCenter}
                title='Action center'
                transparentbutton
              >
                Action center<LinkIcon />
              </Link>
            </div>
          </div>
        </div>
      </ContainerDivs>
    )
  }
}